export function encodePassphrase(passphrase: string) {
  return encodeURIComponent(passphrase);
}

export function decodePassphrase(base64String: string) {
  return decodeURIComponent(base64String);
}

export function randomRoomName(): string {
  function randomEnglishString(length: number): string {
    const characters = 'abcdefghijklmnopqrstuvwxyz';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }

  return `${randomEnglishString(3).toUpperCase()}-${randomEnglishString(3).toUpperCase()}-${randomEnglishString(3).toUpperCase()}`;
}

const ROOM_NAME_REGEX = /^[A-Z]{3}-[A-Z]{3}-[A-Z]{3}$/;

export function isValidRoomName(name: string): boolean {
  return ROOM_NAME_REGEX.test(name.trim());
}

export function randomString(length: number): string {
  let result = '';
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function isLowPowerDevice() {
  return navigator.hardwareConcurrency < 6;
}

export function isMeetStaging() {
  return new URL(location.origin).host === 'meet.staging.livekit.io';
}
